<template>
    <div class="container-fluid">
        <div class="d-flex align-items-center">
            <h2 class="page-heading mr-auto">Создание уведомления</h2>

            <btn-action class="btn btn-info" @click="toggleViewFilters()">Фильтры</btn-action>
            <btn-action class="btn btn-primary ml-2" @click="createNewNotification()">Создать</btn-action>
        </div>
        <div class="card mb-3" v-if="filters.displayed">
            <h3 class="card-header"><span class="text-caps">Фильтры</span></h3>
            <div class="card-body">
                <div class="form-group mb-3" v-if="users.length > 0 && notification.excluded.users == 0">
                    <label>Белый список:</label>
                    <v-multiselect
                        v-model="notification.recipients.users"
                        :options="users"
                        label="name"
                        track-by="id"
                        :multiple="true"
                        :showLabels="true"
                        placeholder="Выберете пользователей"
                        :option-height="30"
                        />
                </div>
                <div class="form-group mb-3" v-if="users.length > 0 && notification.recipients.users == 0">
                    <label>Чёрный список:</label>
                    <v-multiselect
                        v-model="notification.excluded.users"
                        :options="users"
                        label="name"
                        track-by="id"
                        :multiple="true"
                        placeholder="Выберете пользователей"
                        :option-height="30"
                        />
                </div>
                <div class="d-flex">
                    <div class="custom-control custom-checkbox flex-grow-1">
                        <input ref="receipt_checkbox" type="checkbox" class="custom-control-input" id="visible-checkbox" v-model="notification.email">
                        <label class="custom-control-label" for="visible-checkbox">Отправлять на E-mail</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6">
                <div class="card">
                    <h3 class="card-header"><span class="text-caps">Редактор уведомления</span></h3>
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label>Заголовок уведомления:</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="notification.title"
                                placeholder="Введите заголовок"
                            >
                        </div>
                        <div ref="summernoteEditor" class="summernote-editor"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card">
                    <h3 class="card-header"><span class="text-caps">Быстрый предпросмотр</span></h3>
                    <div class="card-body">
                        <h2>{{ notification.title }}</h2>
                        <div v-html="notification.content" class="preview-content fast-preview-content"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-3">
            <h3 class="card-header"><span class="text-caps">Предпросмотр полноэкранный</span></h3>
            <div class="card-body">
                <h2>{{ notification.title }}</h2>
                <div v-html="notification.content" class="preview-content full-preview-content"></div>
            </div>
        </div>
    </div>
</template>
    
<script>
import api from '@/api'

import VueSummernote from 'vue-summernote'
import 'summernote/dist/summernote.css'

export default {
    metaInfo: {title: 'Создание уведомления'},
    components: {
        VueSummernote,
    },
    data () {
        return {
            notification: {
                title: '',
                content: '',
                email: false,
                recipients: {
                    users: [],
                },
                excluded: {
                    users: [],
                },
            },
            editorOptions: {
                height: 300,
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'italic', 'underline', 'clear']],
                    ['fontname', ['fontname']],
                    ['fontsize', ['fontsize']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'video']],
                    ['view', ['fullscreen', 'codeview', 'help']]
                ],
            },
            filters: {
                displayed: false,
            },
            users: [],
            user_roles: [],
        }
    },
    methods: {
        loadUsers() {
            api.get('billing/users/list/get')
                .then(({data}) => {
                    this.users = data;
                    })
                .catch(error => console.log('Ошибка при загрузке пользователей:', error));
            },
        createNewNotification() {
            return api.post('billing/notifications/create', {
                    notification: this.notification,
                })
                .then(({data}) => {
                    console.log(data)
                    })
                .catch( error => console.log(error) )
        },
        toggleViewFilters() {
            this.filters.displayed = !this.filters.displayed;
        },
        initSummernote() {
            $(this.$refs.summernoteEditor).summernote({
                height: this.editorOptions.height,
                toolbar: this.editorOptions.toolbar,
                callbacks: {
                    onChange: (contents) => {
                        this.notification.content = contents;
                        // console.log('Содержимое изменено:', contents);
                    }
                }
            });
        },
    },
    watch: {
    },
    filters: {
    },
    mounted() {
        this.loadUsers();
        this.$nextTick(() => {
            this.initSummernote();
        });
    },
    beforeDestroy() {
        // Очистка редактора перед уничтожением компонента
        if (this.$refs.summernoteEditor) {
            $(this.$refs.summernoteEditor).summernote('destroy');
        }
    },
    asyncComputed: {
    },
}
</script>


<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/notifications/create.vue